<ng-container [ngSwitch]="navType">
  <div class="side-nav" *ngSwitchCase="'SIDE_NAV'">
    <div class="logo-container">
      <nv-logo
        tabindex="0"
        (click)="navigateToHomepage()"
        (keyup)="onKeyUp($event)"
        [pointerOnHover]="true"
        [type]="navLogoType"
        nvAriaLabel
        [ariaLabelText]="navAriaLabels.navBarLogoAltText"
        ariaTargetElement="svg"
      ></nv-logo>
    </div>
    <shared-sidebar-list-responsive
      [listData]="navConfigs.main"
      [selectedKey]="selectedSidebarItem"
      (sidebarListItemSelect)="onNavItemSelect(navConfigs, { selectedItemKey: $event })"
      [styleType]="'SIDE'"
    ></shared-sidebar-list-responsive>
    <div class="nav-extras-container side"><ng-container *ngTemplateOutlet="navExtras"></ng-container></div>
  </div>

  <div class="top-nav-closed top-nav-controls" *ngSwitchCase="'TOP_NAV_CLOSED'">
    <div class="logo-container">
      <nv-logo
        tabindex="0"
        (click)="navigateToHomepage()"
        (keyup)="onKeyUp($event)"
        [pointerOnHover]="true"
        [type]="navLogoType"
        nvAriaLabel
        [ariaLabelText]="navAriaLabels.navBarLogoAltText"
        ariaTargetElement="svg"
      ></nv-logo>
    </div>
    <div class="right-controls">
      @if (translateConfig) {
      <nv-dropdown-box
        [attr.aria-label]="translateConfig.ariaLabel"
        [iconPosition]="translateConfig.iconPosition"
        [leftIconName]="translateConfig.leftIconName"
        [options]="translateConfig.languages"
        [selected]="translateConfig.selectedLangName"
        [size]="translateConfig.size"
        (selectOption)="onSwitchLanguage($event)"
      ></nv-dropdown-box>
      }
      <nv-icon-button
        isInverted="true"
        name="hamburger-large-white"
        [ariaLabelData]="{ 'iconButtonAriaLabel': navAriaLabels.openMenu }"
        (clickButton)="onClickBurgerMenu({ action: 'openTopNavMenu' })"
      ></nv-icon-button>
    </div>
  </div>

  <div class="top-nav-opened" *ngSwitchCase="'TOP_NAV_OPENED'">
    <div class="top-nav-controls">
      <div class="logo-container">
        <nv-logo
          [type]="navLogoType"
          nvAriaLabel
          [ariaLabelText]="navAriaLabels.navBarLogoAltText"
          ariaTargetElement="svg"
        ></nv-logo>
      </div>
      <nv-icon-button
        isInverted="true"
        name="close-large-white"
        [ariaLabelData]="{ iconButtonAriaLabel: navAriaLabels.closeMenu }"
        (clickButton)="onClickBurgerMenu({ action: 'closeTopNavMenu' })"
      >
      </nv-icon-button>
    </div>
    <shared-sidebar-list-responsive
      [listData]="navConfigs.main"
      [selectedKey]="selectedSidebarItem"
      (sidebarListItemSelect)="onNavItemSelect(navConfigs, { selectedItemKey: $event })"
      [styleType]="'FULL_SCREEN'"
    ></shared-sidebar-list-responsive>
    <div class="nav-extras-container full-screen"><ng-container *ngTemplateOutlet="navExtras"></ng-container></div>
    <div class="nav-footer"><ng-content select="[navFooter]"></ng-content></div>
  </div>
</ng-container>
